$.extend({
    shove: function (fn, object) {
        return function () {
            return fn.apply(object, arguments);
        };
    },
});

$.ajaxSetup({
    type: 'get',
    global: true,
    dataType: 'json',
    beforeSend: function (jqXHR, settings) {
        if (settings.type === 'GET' && !/affiliate=/.test(settings.url)) {
            settings.url += /\?/.test(settings.url) ? '&' : '?';
            settings.url +=
                '&affiliate=' + ApplicationProperties.get('affiliate');
        }
    },
    complete: function (data) {
        var hasResponseText =
            typeof data !== 'undefined' && data.hasOwnProperty('responseText');
        var responseIsJson =
            stj &&
            stj.global.isJsonString &&
            true === stj.global.isJsonString(data.responseText);
        if (hasResponseText && responseIsJson) {
            var response = JSON.parse(data.responseText);
            if (null !== response) {
                if (
                    response.hasOwnProperty('redirect') &&
                    response.redirect === true
                ) {
                    window.location.reload();
                    return false;
                }
            }
        }
    },
});

Date.prototype.addDays = function (days) {
    var dat = new Date(this.valueOf());
    dat.setDate(dat.getDate() + days);
    return dat;
};

if (typeof $.browser === 'undefined') {
    $.browser = {};
    $.browser.mozilla =
        /mozilla/.test(navigator.userAgent.toLowerCase()) &&
        !/webkit/.test(navigator.userAgent.toLowerCase());
    $.browser.webkit = /webkit/.test(navigator.userAgent.toLowerCase());
    $.browser.opera = /opera/.test(navigator.userAgent.toLowerCase());
    $.browser.msie = /msie/.test(navigator.userAgent.toLowerCase());
    $.browser.version = true;
}
